import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { logoutUser } from "../../redux/apiCalls/authApiCall";

function HeaderRight() {


  const {user} = useSelector(state => state.auth);
  const dispatch = useDispatch()

   

  return (
    <div className="header-right">
      {/* User info (static for now) */}
      <div className="header-user">
        <i className="bi bi-person-circle"></i>
        <span className="header-username">{user?.userName}</span>
      </div>

      {/* Logout button */}
      <Link  onClick={() => dispatch(logoutUser())} to="/login" className="header-right-link header-logout">
        <i className="bi bi-box-arrow-right"></i>
        <span>Logout</span>
      </Link>
    </div>
  );
}

export default HeaderRight;
